import type { ComponentChildren } from "preact";
import { cx } from "./lib/cx.ts";

/** What a list shows when it has nothing. Rule: one bare, muted sentence; no icon, no panel, no border, no call to action dressed as a card. */
export function EmptyState({ children, class: className }: { children?: ComponentChildren; class?: string }) {
  return <p class={cx("ui-empty", className)}>{children}</p>;
}
